<div
	class="flex-col items-center justify-center h-full px-4 py-10 text-center bg-gray-50"
	[ngClass]="{ 'py-12': !isFeatured() }"
>
	<span class="mb-4 text-5xl">🗓</span>
	<p class="mt-6 text-3xl font-bold leading-6">
		{{ (applicationDeadline() | date: 'dd MMMM') ?? 'Varied' }}
	</p>
	<p
		class="max-w-4xl mt-1 mb-5 text-lg text-gray-500"
		[ngClass]="{ 'mb-0': !isFeatured() }"
	>
		Application deadline
	</p>
	@if (externalUrl() && isFeatured()) {
		<uc-visit-website-btn
			class="hidden sm:block"
			[externalUrl]="externalUrl()"
			[product]="product()"
			componentName="How to apply"
			[uniId]="uniId()"
			[uniName]="uniName()"
			buttonText="Get More Course Information"
			[source]="courseName()"
			sourceType="course"
			[ugSearchOrderPosition]="ugSearchOrderPosition()"
			data-cy="application-details-visit-website-btn"
		/>
	}
</div>
